import type { ValidationResult } from '../helpers/types';
import { formatValidationResponse } from '../helpers/utils';

export const MIN_LENGTH = 8;
export const MAX_LENGTH = 20;

const minLengthMessage = `Should have at least ${MIN_LENGTH} characters`;
const maxLengthMessage = `Should have less or equal than ${MAX_LENGTH} characters`;

export const validateMinLength = (password: string): ValidationResult => {
  const isRuleValid = password.length >= MIN_LENGTH;
  return formatValidationResponse(isRuleValid, minLengthMessage);
};

export const validateMaxLength = (password: string): ValidationResult => {
  const isRuleValid = password.length <= MAX_LENGTH;
  return formatValidationResponse(isRuleValid, maxLengthMessage);
};
